var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-dialog",
        {
          attrs: {
            width: "550px",
            title: "Edit Preference",
            visible: _vm.dialogVisible,
            scrollbar: false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            open: _vm.onOpen,
            closed: _vm.onClosed,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.form,
                rules: _vm.formRules,
                "label-width": "250px",
                "label-position": "left",
              },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    prop: "DiseaseState",
                    label: "Disease State Presentation",
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "200px" },
                      attrs: {
                        placeholder: "Please Choose",
                        clearable: "",
                        filterable: "",
                      },
                      model: {
                        value: _vm.form.DiseaseState,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "DiseaseState", $$v)
                        },
                        expression: "form.DiseaseState",
                      },
                    },
                    _vm._l(_vm.options, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    prop: "NilexDisease",
                    label: "NILEX Disease State Presentation",
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "200px" },
                      attrs: {
                        placeholder: "Please Choose",
                        clearable: "",
                        filterable: "",
                      },
                      model: {
                        value: _vm.form.NilexDisease,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "NilexDisease", $$v)
                        },
                        expression: "form.NilexDisease",
                      },
                    },
                    _vm._l(_vm.options, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    prop: "ProductOverview",
                    label: "Product Overview Presentation",
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "200px" },
                      attrs: {
                        placeholder: "Please Choose",
                        clearable: "",
                        filterable: "",
                      },
                      model: {
                        value: _vm.form.ProductOverview,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "ProductOverview", $$v)
                        },
                        expression: "form.ProductOverview",
                      },
                    },
                    _vm._l(_vm.options, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    prop: "MedicalEducation",
                    label: "Medical Education Inform",
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "200px" },
                      attrs: {
                        placeholder: "Please Choose",
                        clearable: "",
                        filterable: "",
                      },
                      model: {
                        value: _vm.form.MedicalEducation,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "MedicalEducation", $$v)
                        },
                        expression: "form.MedicalEducation",
                      },
                    },
                    _vm._l(_vm.options, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    prop: "InformActivity",
                    label: "Inform Activity (Label/Guideline Inform)",
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "200px" },
                      attrs: {
                        placeholder: "Please Choose",
                        clearable: "",
                        filterable: "",
                      },
                      model: {
                        value: _vm.form.InformActivity,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "InformActivity", $$v)
                        },
                        expression: "form.InformActivity",
                      },
                    },
                    _vm._l(_vm.options, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    prop: "SafetyData",
                    label: "Safety Data Dissemination",
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "200px" },
                      attrs: {
                        placeholder: "Please Choose",
                        clearable: "",
                        filterable: "",
                      },
                      model: {
                        value: _vm.form.SafetyData,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "SafetyData", $$v)
                        },
                        expression: "form.SafetyData",
                      },
                    },
                    _vm._l(_vm.options, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "actions" },
            [
              _c("el-button", { on: { click: _vm.onClosed } }, [
                _vm._v("Cancel"),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.loading },
                  on: { click: _vm.onConfirm },
                },
                [_vm._v(" " + _vm._s(_vm.loading ? "Saving" : "Save") + " ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }